/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Dashboard from "views/Dashboard.jsx";
import Analytics from "views/Analytics.jsx";
import Forms from "views/Forms.jsx";
import TrackableLinks from "views/TrackableLinks.jsx";
import UserProfile from "views/UserProfile.jsx";
import TableList from "views/TableList.jsx";
import CloudPublicationList from "views/CloudPublicationList.jsx";
import Login from "views/Login.jsx";
import ForgotPassword from "views/ForgotPassword.jsx";
import ConfirmResetPassword from "views/ConfirmResetPassword.jsx";
import ConfirmEmail from "views/ConfirmEmail.jsx";
import Invoices from "views/Invoices.jsx";
import Downloads from "views/Downloads.jsx";
import Leads from "views/Leads.jsx";
import HeatMap from "views/HeatMap.jsx";
import Redirect from "components/Redirect.jsx";
import LicenseKeyActivation from "views/LicenseKeyActivation.jsx";
import ArchivedDownloads from "views/ArchivedDownloads.jsx";
import SetPassword from "views/SetPassword.jsx";
import Icons from "views/Icons.jsx";
import Maps from "views/Maps.jsx";
import Notifications from "views/Notifications.jsx";
import Upgrade from "views/Upgrade.jsx";

const dashboardRoutes = [
  {
    path: "/login",
    name: "Login",
    icon: "pe-7s-user",
    component: Login,
    layout: "/home",
    loggedInComponent : false
  },{
    path: "/forgotpassword",
    name: "ForgotPassword",
    icon: "pe-7s-user",
    component: ForgotPassword,
    layout: "/home",
    loggedInComponent : false,
    hidden : true
  },{
    path: "/reset-password",
    name: "ConfirmResetPassword",
    icon: "pe-7s-user",
    component: ConfirmResetPassword,
    layout: "/home",
    loggedInComponent : false,
    hidden : true
  },{
    path: "/confirm-email",
    name: "Confirm Email",
    icon: "pe-7s-user",
    component: ConfirmEmail,
    layout: "/home",
    loggedInComponent : false,
    hidden : true
  },{
    path: "/user",
    name: "Account",
    icon: "pe-7s-user",
    component: UserProfile,
    layout: "/home",
    loggedInComponent : true
  },{
    path: "/setpassword",
    name: "SetPassword",
    icon: "pe-7s-user",
    component: SetPassword,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: "pe-7s-graph",
  //   component: Dashboard,
  //   layout: "/home"
  // },

  // WIP
  {
    path: "/analytics/:publication/:identifier",
    name: "Analytics",
    icon: "pe-7s-graph",
    component: Analytics,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },
  {
    path: "/forms/:publication",
    name: "Forms",
    icon: "pe-7s-graph",
    component: Forms,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },
  {
    path: "/trackablelinks/:publication",
    name: "TrackableLinks",
    icon: "pe-7s-graph",
    component: TrackableLinks,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },  
  {
    path: "/downloads",
    name: "Downloads",
    icon: "pe-7s-download",
    component: Downloads,
    layout: "/home",
    loggedInComponent : true
  },
  {
    path: "/app",
    name: "Desktop Publisher",
    icon: "pe-7s-airplay",
    component: Redirect,
    layout: "/home",
    loggedInComponent : true
  },
  {
    path: "/cloud",
    name: "Cloud Publications",
    icon: "pe-7s-cloud",
    component: CloudPublicationList,
    layout: "/home",
    loggedInComponent : true
  },
  {
    path: "/invoices",
    name: "Invoices",
    icon: "pe-7s-news-paper",
    component: Invoices,
    layout: "/home",
    loggedInComponent : true
  },
  {
    path: "/activation",
    name: "License Key Activation",
    icon: "pe-7s-star",
    component: LicenseKeyActivation,
    layout: "/home",
    loggedInComponent : true
  },
  {
    path: "/leads/:publication",
    name: "Collected Leads",
    icon: "pe-7s-share",
    component: Leads,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },
  {
    path: "/heatmap/:publication/:identifier",
    name: "Heatmap",
    icon: "pe-7s-share",
    component: HeatMap,
    layout: "/home",
    loggedInComponent : true,
    hidden : true
  },
  {
    path: "/downloadarchive",
    name: "Archived Downloads",
    icon: "pe-7s-box1",
    component: ArchivedDownloads,
    layout: "/home",
    loggedInComponent : true
  },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "pe-7s-science",
  //   component: Icons,
  //   layout: "/admin"
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "pe-7s-map-marker",
  //   component: Maps,
  //   layout: "/admin"
  // },
  // {
  //   path: "/notifications",
  //   name: "Notifications",
  //   icon: "pe-7s-bell",
  //   component: Notifications,
  //   layout: "/admin"
  // },
  // {
  //   upgrade: true,
  //   path: "/upgrade",
  //   name: "Upgrade to PRO",
  //   icon: "pe-7s-rocket",
  //   component: Upgrade,
  //   layout: "/admin"
  // }
];

export default dashboardRoutes;
